import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function FinalCTA() {
  const {
    t
  } = useLanguage();
  return <section id="cta" className="min-h-screen flex items-center justify-center relative overflow-hidden bg-[#000000] py-24 px-8" data-id="element-32">
      <div className="absolute inset-0 cta-bg" data-id="element-33"></div>
      <div className="absolute inset-0 cta-grid-lines opacity-50" data-id="element-34"></div>

      {/* Ambient luxury glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-crimson/5 rounded-full blur-[120px] pointer-events-none" data-id="element-35"></div>

      <motion.div initial={{
      opacity: 0,
      y: 40,
      scale: 0.98
    }} whileInView={{
      opacity: 1,
      y: 0,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 1.6,
      ease: [0.16, 1, 0.3, 1]
    }} className="relative z-10 text-center max-w-[900px] w-full" data-id="element-36">
        <span className="font-sans text-[10px] tracking-[8px] uppercase text-crimson-glow font-medium mb-10 block opacity-90" data-id="element-37">
          {t('cta.label')}
        </span>

        <h2 className="font-serif text-[48px] sm:text-[64px] lg:text-[100px] font-medium leading-[1.05] text-white tracking-[-0.02em] mb-8 [text-shadow:0_10px_40px_rgba(0,0,0,0.8)]" data-id="element-38">
          {t('cta.headline')}
        </h2>

        <p className="font-sans text-[16px] lg:text-[18px] text-white/50 font-light tracking-[0.02em] mb-16 leading-[1.9]" dangerouslySetInnerHTML={{
        __html: t('cta.subheadline')
      }} data-id="element-39" />

        <div className="flex flex-col sm:flex-row justify-center gap-5" data-id="element-40">
          <motion.a href="#" animate={{
          boxShadow: ['0 0 0 0 rgba(153,0,0,0.4)', '0 0 0 20px rgba(153,0,0,0)', '0 0 0 0 rgba(153,0,0,0)']
        }} transition={{
          duration: 3,
          repeat: Infinity,
          ease: 'easeOut'
        }} whileHover={{
          y: -2,
          scale: 1.01
        }} whileTap={{
          scale: 0.98
        }} className="bg-crimson text-white px-12 py-5 text-[11px] tracking-[4px] uppercase font-semibold rounded-sm inline-flex items-center justify-center gap-4 relative overflow-hidden btn-primary-hover hover:bg-crimson-glow hover:shadow-[0_20px_40px_rgba(122,0,0,0.4)] group w-full sm:w-auto" data-id="element-41">
            <motion.span aria-hidden="true" className="absolute inset-y-0 -left-1/2 w-1/2 bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-[-20deg] pointer-events-none" animate={{
            left: ['-50%', '150%']
          }} transition={{
            duration: 3,
            repeat: Infinity,
            repeatDelay: 2,
            ease: 'easeInOut'
          }} data-id="element-42" />
            <span className="relative z-10 font-sans" data-id="element-43">
              {t('cta.btn.primary')}
            </span>
            <motion.span className="relative z-10 inline-flex" animate={{
            x: [0, 4, 0]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-44">
              <ArrowRight className="w-4 h-4" strokeWidth={1.5} data-id="element-45" />
            </motion.span>
          </motion.a>

          <a href="#" className="bg-white/[0.02] text-white px-12 py-5 text-[11px] tracking-[4px] uppercase font-medium border border-white/[0.08] rounded-sm inline-flex items-center justify-center gap-3 backdrop-blur-xl transition-all duration-500 hover:bg-white/[0.06] hover:border-white/[0.15] hover:-translate-y-0.5 w-full sm:w-auto" data-id="element-46">
            <span className="font-sans" data-id="element-47">{t('cta.btn.secondary')}</span>
          </a>
        </div>

        <div className="w-[80px] h-px bg-gradient-to-r from-transparent via-white/20 to-transparent mx-auto mt-24" data-id="element-48"></div>
      </motion.div>
    </section>;
}